<template>
  <div>
    <Form
      page-title="Add a new Business"
      buttonName="Submit"
      :isCreateMode="true"
      :isInList="isInList"
      @submit="submit"
      ref="BusinessForm"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { createBusiness } from "@/API/BusinessAPIs";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "Create",
  props: ["isInList"],
  components: { Form },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async submit(formData) {
      const callback = () => {
        this.$refs.BusinessForm.resetForm();
      };
      submitAndNotify(this, createBusiness(formData), callback);
    }
  }
};
</script>
<style></style>
